import React, { lazy, Suspense, useCallback, useRef, useState } from "react";
import { SubHeading } from "../../shared/Components";
import CommonModal from "../../shared/Components/Modal/CommonModal";
import RolesModal from "../../shared/Components/Modal/ConfigurationModal/RolesModal";
import { API_ROLES } from "../../utils/api/ApiConstant";
import { getAxios } from "../../shared/Services/commonService";
import { useAccessControl } from "../../shared/Hooks/useAccessControl";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";

const ConfigRolesBody = lazy(() => import("./ConfigRolesBody"));
const ConfigRoles = () => {
  const LoggedInUserId = useSelector((state) => state.user?.user?.id);

  const {
    data,
    isLoading,
    refetch: rolesRefetch,
  } = useQuery({
    queryKey: ["configRolesData", LoggedInUserId],
    queryFn: () => getAxios(API_ROLES),
    enabled: !!LoggedInUserId,
  });

  const allottedPermissions = useAccessControl();

  const [isShow, setIsShow] = useState({
    isOpen: false,
    rowData: null,
    name: "",
    modalTitle: "",
    modalContent: null,
    apiFlag: false,
  });

  const handleModal = (rowData, title = "") => {
    setIsShow({
      isOpen: true,
      modalContent: RolesModal,
      modalTitle: title,
      rowData,
    });
  };

  return (
    <>
      <SubHeading
        isAdd={true}
        handleShowHide={() => handleModal({}, "Create")}
      />

      <Suspense fallback={<div>Loading...</div>}>
        <ConfigRolesBody
          onEdit={(rowData) => handleModal(rowData, "Edit")}
          fetchData={rolesRefetch}
          data={data}
          isLoading={isLoading}
        />
      </Suspense>
      {isShow?.isOpen && (
        <CommonModal
          isShow={isShow.isOpen}
          handleModalHide={() =>
            setIsShow((prev) => ({
              ...prev,
              isOpen: false,
              rowData: {},
              name: "",
            }))
          }
          modalTitle={isShow.modalTitle}
        >
          {isShow.modalContent &&
            React.createElement(isShow.modalContent, {
              handleModalHide: () =>
                setIsShow((prev) => ({
                  ...prev,
                  isOpen: false,
                  rowData: {},
                  name: "",
                  modalTitle: "",
                  apiFlag: !prev.apiFlag,
                })),
              rowData: {
                ...isShow.rowData,
              },
              fetchData: rolesRefetch,
            })}
        </CommonModal>
      )}
    </>
  );
};

export default ConfigRoles;
